<template>
  <div class="submit-confirmation-overlay">
    <div class="submit-confirmation">
      <h1 class="confirmation-title">
        Submit {{ reportName }}
      </h1>
      <p class="confirmation-text">
        Once submitted, it will no longer be available for editing.
      </p>
      <div class="confirmation-buttons">
        <button class="submit-button" @click="confirmSubmit">
          <span>Submit</span>
        </button>
        <button class="cancel-button" @click="cancelPopup">
          <span>Cancel</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {

    };
  },
  methods: {
    async confirmSubmit() {
      await this.onConfirm();
    },
    cancelPopup() {
      if (this.onCancel) {
        this.onCancel();
      }
    },
  },
  props: {
    onConfirm: Function,
    onCancel: Function,
    reportName: String,
  },
};
</script>

<style scoped>

  .submit-confirmation-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .confirmation-title {
    margin: 0 0 17px 0;
    font-size: 34px;
  }

  .submit-confirmation {
    background-color: #fff;
    padding: 30px 40px;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    text-align: center;
  }

  .confirmation-text {
    margin: 0 0 25px 0;
    font-size: 17px;
  }

  .confirmation-buttons {
    display: flex;
    justify-content: space-around;
  }

  .submit-button,
  .cancel-button {
    font-size: 18px;
    padding: 10px 35px;
    border: 2px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    width: max-content;
  }

  .submit-button span,
  .cancel-button span {
    text-transform: uppercase;
    font-weight: 500;
    color: #fff;
  }

  .submit-button {
    background: linear-gradient(to bottom,#3c6399 0%,#0f2e50 100%);
  }

  .submit-button:hover{
    border-color: #3c6399;
    background: #fff;
  }

  .submit-button:hover span {
    color: #3c6399;
  }

  .cancel-button {
    background-color: #999;
  }

  .cancel-button:hover{
    border-color: #999;
    background: #fff;
  }

  .cancel-button:hover span {
    color: #999;
  }

</style>